import React from 'react';
import * as Icon from 'react-feather';

export default function Infra() {
  return (
    <section class="features-area ptb-80 bg-f7fafd">
			<div class="container">
				<div class="section-title">
					
					<h2>Infrastructure</h2>
					<div class="bar"></div>
					<p>With over 17 years of experience, VSK Textiles Private Limited is a reputable textile manufacturer, supplying high-quality woven fabrics for diverse end-use applications. </p>
				</div>

				<div class="row">
				
					<div class="col-lg-6 col-md-6" >	
						<img src="/img/infra2.png" class="wow zoomIn  w-100" data-wow-delay="0.6s" alt="imgbeside"/>
			   </div>
					<div class="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.8s">
						<div class="single-features mt-5">
							<div class="icon">
								<Icon.AlignCenter/>
							</div>
							<h3>Weaving</h3>
							<p>Following spinning, the yarn undergoes sizing, applying a protective coating to ensure durability during weaving. The sized yarns are then expertly interlaced on looms by skilled artisans, creating the fabrics that will ultimately adorn fashion and home goods stores.</p>
						</div>
					</div>
					
					<div class="col-lg-6 col-md-6 wow fadeInUp p-1" data-wow-delay="0.8s" style={{backgroundColor:" #e7f6ff"}}>
						<div class="single-features mt-5">
							<div class="icon bg-c679e3">
								<Icon.Grid/>
							</div>

							<h3>Checking</h3>
							<p>Throughout this journey, vigilant quality checks, from visual inspections to meticulous testing, ensure that every product meets the highest standards.</p>
						</div>
					</div>
					<div class="col-lg-6 col-md-6 wow fadeInUp p-1" data-wow-delay="0.8s" style={{backgroundColor:" #e7f6ff"}}>	
						<img src="/img/infra3.png" class="wow zoomIn w-100" data-wow-delay="0.6s" alt="imgbeside"/>
			   </div>
			   <div class="col-lg-6 col-md-6">	
				<img src="/img/process.png"  class="wow zoomIn w-100" data-wow-delay="0.6s" alt="imgbeside"/>
	   </div>
					<div class="col-lg-6 col-md-6">
						<div class="single-features mt-5">
							<div class="icon bg-c679e3">
								<Icon.Crosshair/>
							</div>

							<h3>Processing</h3>
							<p>Once the fabric is woven, it undergoes dyeing and printing, where skilled technicians enhance its aesthetic with vibrant colors and intricate designs.</p>
						</div>
					</div>
                    <div class="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.8s">
						<div class="single-features mt-5">
							<div class="icon bg-eb6b3d">
								<Icon.Layers/>
							</div>

							<h3>Packing</h3>
							<p>From the careful folding and packaging of finished products to the coordinated logistics ensuring timely delivery, every aspect of our process is designed to create textile masterpieces ready to be enjoyed by consumers worldwide.</p>
						</div>
					</div>
					<div class="col-lg-6 col-md-6">	
				<img src="/img/pack.png" class="wow zoomIn w-100" data-wow-delay="0.6s" alt="imgbeside"/>
	   </div>
					
				</div>
			</div>
		</section>
  )
}
